import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileCheck, AlertCircle, RefreshCw } from 'lucide-react';

export default function EditorialPolicyPage() {
  return (
    <main className="pt-20 min-h-screen">
      <div className="container-ninja section-spacing max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Blog
        </Link>

        <h1 className="text-4xl sm:text-5xl uppercase tracking-wider text-white mb-8" style={{ fontFamily: 'Bebas Neue, sans-serif' }} data-testid="editorial-heading">
          Editorial Policy
        </h1>
        <p className="text-zinc-400 mb-10 text-sm leading-relaxed">
          At NinjAthlete, we hold ourselves to a high standard of accuracy, transparency, and integrity across all published content. Our readers trust us with health-related (YMYL) topics, and we take that responsibility seriously.
        </p>

        {/* Sections */}
        <div className="space-y-10">
          <PolicySection icon={FileCheck} title="Content Standards">
            <ul className="space-y-3">
              <li>All health and peptide content is written for educational purposes only and is clearly labeled as such.</li>
              <li>Claims are supported by peer-reviewed research, cited with DOI or PubMed links where available.</li>
              <li>HYROX training content is based on the author's personal competition experience (HYROX Dallas 59:51) and established coaching methodologies.</li>
              <li>Product recommendations include clear disclosure of affiliate relationships.</li>
              <li>We distinguish between evidence from human clinical trials, animal studies, and in vitro research.</li>
            </ul>
          </PolicySection>

          <PolicySection icon={AlertCircle} title="Fact-Checking Policy">
            <ul className="space-y-3">
              <li>All factual claims in peptide and health articles are verified against primary sources before publication.</li>
              <li>Dosing information is cross-referenced against published clinical trial protocols.</li>
              <li>Statistics and data points include their original source and date.</li>
              <li>We do not publish unverified anecdotal claims as medical evidence.</li>
            </ul>
          </PolicySection>

          <PolicySection icon={RefreshCw} title="Review & Corrections Policy">
            <ul className="space-y-3">
              <li>All YMYL (Your Money or Your Life) articles are reviewed and updated on a quarterly cycle.</li>
              <li>Each reviewed article displays a "Last reviewed" date stamp visible to readers.</li>
              <li>When new research invalidates or updates previous content, we publish corrections promptly with a note explaining what changed and why.</li>
              <li>Readers can report factual errors to <a href="mailto:hello@ninjathlete.com" className="text-[#E63946] underline">hello@ninjathlete.com</a>.</li>
              <li>Corrected articles include an editor's note at the top with the date and nature of the correction.</li>
            </ul>
          </PolicySection>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800 text-zinc-600 text-xs">
          <p>Last updated: April 2026</p>
          <p className="mt-2">Questions about our editorial standards? Contact <a href="mailto:hello@ninjathlete.com" className="text-zinc-400 underline">hello@ninjathlete.com</a></p>
        </div>
      </div>
    </main>
  );
}

function PolicySection({ icon: Icon, title, children }) {
  return (
    <div className="bg-zinc-900/60 border border-zinc-800 p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon className="w-5 h-5 text-[#E63946]" />
        <h2 className="text-lg uppercase tracking-wider text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>{title}</h2>
      </div>
      <div className="text-zinc-400 text-sm leading-relaxed">{children}</div>
    </div>
  );
}
